import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import useStyles from './styles'

const GrowthChartTooltip = ({ active, payload, valueFormatter }) => {
  const classes = useStyles()

  if (!active || !payload?.length) {
    return null
  }

  const entry = payload[0]
  const label = entry.name || entry.payload?.label || ''
  const value = valueFormatter
    ? valueFormatter(entry.value, label)
    : entry.value

  return (
    <Box className={classes.chartTooltip}>
      <Typography component="div" className={classes.chartTooltipLabel}>
        {label}
      </Typography>
      <Typography component="div" className={classes.chartTooltipValue}>
        {value}
      </Typography>
    </Box>
  )
}

export default GrowthChartTooltip
